import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=7ba0fd18&scoped=true&"
import script from "./CartDetail.vue?vue&type=script&lang=ts&"
export * from "./CartDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CartDetail.vue?vue&type=style&index=0&id=7ba0fd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0fd18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
